export const INTERVIEW_PATH = '/interview';

export const INTERVIEW_NAV_BAR_HEIGHT = `calc(5rem + env(safe-area-inset-top))`;
